const deepLinkStorageKey = "deepLink";

const storeDeepLink = () => {
  if (
    window.location.pathname.includes("/dashboard") ||
    window.location.pathname.includes("/profile")
  ) {
    return;
  }
  const currentLocation = `${window.location.pathname}${window.location.search}`;
  localStorage.setItem(deepLinkStorageKey, currentLocation);
};

const consumeDeepLink = () => {
  const storedValue = localStorage.getItem(deepLinkStorageKey);
  localStorage.removeItem(deepLinkStorageKey);
  return storedValue;
};

export { consumeDeepLink, storeDeepLink };
